import { Request } from './Request';

export interface IGetUserAlertCountParams {
}

export interface IGetUserAlertCountResult {
  totalCount: number;
}

export class GetUserAlertCountRequest extends Request<IGetUserAlertCountParams, IGetUserAlertCountResult> {
  constructor(params: IGetUserAlertCountParams = {}) {
    super('getUserAlertCount', params);
  }
}
